import { useLang } from "@/context/LanguageContext";

export function SectionHeading({ overline, title, titleDeva, description, align = "left", action, divider = false }) {
  const { lang } = useLang();
  const isDeva = lang !== "en";
  // Never mix scripts: show Devanagari in Hindi mode, English otherwise.
  const shown = isDeva ? (titleDeva || title) : (title || titleDeva);
  const showDeva = isDeva && !!titleDeva;
  return (
    <div className={`flex flex-col ${align === "center" ? "items-center text-center" : "items-start"} ${action ? "md:flex-row md:items-end md:justify-between" : ""}`}>
      <div className={align === "center" ? "max-w-2xl" : ""}>
        {overline && <p className="overline-label mb-3">{overline}</p>}
        <h2 className={`leading-tight text-ink deva-lh ${showDeva ? "font-deva text-4xl md:text-5xl" : "font-serif-latin text-3xl md:text-4xl"}`}>
          {shown}
        </h2>
        {divider && (
          <div className={`mt-5 flex items-center gap-3 ${align === "center" ? "justify-center" : ""}`} aria-hidden="true">
            <span className="h-px w-16 bg-[var(--gold-muted)]" />
            <span className="h-1.5 w-1.5 rotate-45 bg-[var(--gold)]" />
            <span className="h-px w-16 bg-[var(--gold-muted)]" />
          </div>
        )}
        {description && (
          <p className="tg-explainer mt-3 max-w-xl text-base leading-relaxed text-ink-2">{description}</p>
        )}
      </div>
      {action && <div className="mt-4 md:mt-0">{action}</div>}
    </div>
  );
}

export default SectionHeading;
